import React, { useState } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { EntAlertView } from '@ent-ui-kit/react';
import { KiteDialog } from '@kite/react-kite';
import { genericErrorMessage } from 'utils/copyText';

const ErrorBoundaryDialog = ({ resetErrorBoundary }: FallbackProps) => {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    resetErrorBoundary();
    setShow(false);
  };

  return (
    <KiteDialog
      title=""
      open={show}
      onClose={handleClose}
      primaryBtnLabel="Close"
      onPrimaryBtnClick={handleClose}
    >
      <EntAlertView type="error" title={genericErrorMessage} />
    </KiteDialog>
  );
};

export default ErrorBoundaryDialog;
